/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Tlm_1Inputs */

const en_svc_ai_agent_development_tlm_1 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`orchestration_engine`)
};

const ar_svc_ai_agent_development_tlm_1 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محرك التنسيق`)
};

const bn_svc_ai_agent_development_tlm_1 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`orchestration_engine`)
};

const de_svc_ai_agent_development_tlm_1 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orchestration_Engine`)
};

const es_svc_ai_agent_development_tlm_1 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`motor_de_orquestación`)
};

const fr_svc_ai_agent_development_tlm_1 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`moteur_d'orchestration`)
};

const pt_svc_ai_agent_development_tlm_1 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`orquestração_motor`)
};

const zh_svc_ai_agent_development_tlm_1 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orchestration_engine`)
};

const tr_svc_ai_agent_development_tlm_1 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`orkestrasyon_motoru`)
};

const ru_svc_ai_agent_development_tlm_1 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`оркестратор_движок`)
};

const pl_svc_ai_agent_development_tlm_1 = /** @type {(inputs: Svc_Ai_Agent_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`orkiestracja_silnik`)
};

/**
* | output |
* | --- |
* | "orchestration_engine" |
*
* @param {Svc_Ai_Agent_Development_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_tlm_1 = /** @type {((inputs?: Svc_Ai_Agent_Development_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_tlm_1(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_tlm_1(inputs)
	if (locale === "de") return de_svc_ai_agent_development_tlm_1(inputs)
	if (locale === "es") return es_svc_ai_agent_development_tlm_1(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_tlm_1(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_tlm_1(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_tlm_1(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_tlm_1(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_tlm_1(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_tlm_1(inputs)
	return en_svc_ai_agent_development_tlm_1(inputs)
});
export { svc_ai_agent_development_tlm_1 as "svc_ai-agent-development_tlm_1" }